import { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
import { Container, Button, Form, Card, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function HomePage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Redirect logged-in users to dashboard
  useEffect(() => {
    const checkUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) navigate("/dashboard");
    };
    checkUser();
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      navigate("/dashboard");
    }
  };

  const handleSignUp = async () => {
    setLoading(true);
    setError(null);
    
    const { error } = await supabase.auth.signUp({
      email,
      password,
    });

    if (error) {
      setError(error.message);
    } else {
      alert("Check your email for the confirmation link!");
    }
    setLoading(false);
  };

  return (
    <Container className="d-flex flex-column align-items-center mt-5">
      <img src="/favicon.ico" alt="FLOC Logo" style={{ width: '64px' }} className="mb-3" />
      <h1 className="display-4 mb-3">FLOC</h1>
      <p className="lead mb-4">Professional Translation Request Platform</p>

      <Card style={{ width: '100%', maxWidth: '400px' }} className="shadow">
        <Card.Body>
          <Card.Title className="text-center mb-4">Login or Sign Up</Card.Title>
          
          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleLogin}>
            <Form.Group className="mb-3">
              <Form.Label>Email address</Form.Label>
              <Form.Control 
                type="email" 
                placeholder="name@example.com" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control 
                type="password" 
                placeholder="Password" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>

            <div className="d-grid gap-2">
              <Button variant="primary" type="submit" disabled={loading}>
                {loading ? "Processing..." : "Sign In"}
              </Button>
              <Button variant="outline-secondary" onClick={handleSignUp} disabled={loading}>
                Create New Account
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}